import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import CenterPanel from './centerPanel';
import AccordionSession from './accordion';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import ModalSetMinDurations from '../../../../containers/ReportSetMinDurationPage';
import PageHeader from '../../header';
import { Container } from 'semantic-ui-react';
import { breakpoints } from '../../../../mediaSetting';
import { hideDataOutOfDateWarning } from '../../../../actions/report';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';
import { updateFilterValue } from 'actions/organisation';

export default function ViewAllReportsContent(props) {
  const isMobileOrTablet = useMediaQuery({
    query: `(max-width: ${breakpoints.computer}px)`,
  });

  const dispatch = useDispatch();
  const [ifEndDateGreaterThanToday, setIfEndDateGreaterThanToday] = useState(false);
  const [isOnMobileOrTablet, setIsOnMobileOrTablet] = useState(
    window.innerWidth < window.styleVariable.computerMinWidth
  );

  let bottomSession = <AccordionSession fetchingReports={props.fetchingReports} />;

  useEffect(() => {
    dispatch(updateFilterValue(1));

    return () => {
      dispatch(hideDataOutOfDateWarning(false));
    };
  }, []);
  useEffect(() => {
    window.addEventListener('resize', (event) =>
      setIsOnMobileOrTablet(window.innerWidth < window.styleVariable.computerMinWidth)
    );

    return () => {
      window.removeEventListener('resize', (event) =>
        setIsOnMobileOrTablet(window.innerWidth < window.styleVariable.computerMinWidth)
      );
    };
  }, []);
  useEffect(() => {
    // Check if enddate in date picker is today or after today
    setIfEndDateGreaterThanToday(
      props.startDate && props.endDate && moment(props.endDate).diff(moment().utcOffset(props.timezone), 'days') >= 0
        ? true
        : false
    );
  }, [props.startDate, props.endDate]);

  return (
    <div className="main-ui-container meeting-room-view-all new-waiting-area-view-one">
      {!isOnMobileOrTablet ? (
        <Container fluid className="row">
          <div className="left-hand-side-panel">
            <div className="relative mrrm">
              <PageHeader
                title={APP.LANGUAGE.MainReport.Title}
                titleColor="color-primary-dark-grey"
                notRenderLogo={true}
              >
                <span>
                  <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.ReportPageIcon.default} />
                </span>
              </PageHeader>
            </div>
            <div className="view-all-meeting-room-container pdlm pdrm">
              {props.hasReports && !isMobileOrTablet && (
                <CenterPanel
                  noHeader={false}
                  reports={props.reports}
                  timezone={props.timezone}
                  fetchingReports={props.fetchingReports}
                  minConsultationDurValue={props.minConsultationDurValue}
                  minMeetingDurValue={props.minMeetingDurValue}
                  showSetMinDurationsModal={props.showSetMinDurationsModal}
                  startDate={props.startDate}
                  endDate={props.endDate}
                  isAdmin={props.isAdmin}
                  hasMoreThanOneOrg={props.hasMoreThanOneOrg}
                />
              )}
            </div>
          </div>
          <div className="right-hand-side-panel color-right-hand-side-panel-bg">
            <RightPanelOrTopPanel
              minConsultationDurValue={props.minConsultationDurValue}
              minMeetingDurValue={props.minMeetingDurValue}
              fetchingReports={props.fetchingReports}
              bottomSession={bottomSession}
              hideDataOutdateWarning={props.hideDataOutdateWarning || !ifEndDateGreaterThanToday} // only show when it navigates back && date is today or greater than today
            />
          </div>
        </Container>
      ) : (
        <Container fluid>
          <div className="left-hand-side-panel-mobile">
            <PageHeader title={APP.LANGUAGE.MainReport.Title} titleColor="color-primary-dark-grey" notRenderLogo={true}>
              <span>
                <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.ReportPageIcon.default} />
              </span>
            </PageHeader>
            <div className="right-hand-side-panel-mobile" />
            <div>
              {props.hasReports && isMobileOrTablet && (
                <CenterPanel
                  noHeader={false}
                  reports={props.reports}
                  timezone={props.timezone}
                  fetchingReports={props.fetchingReports}
                  minConsultationDurValue={props.minConsultationDurValue}
                  minMeetingDurValue={props.minMeetingDurValue}
                  showSetMinDurationsModal={props.showSetMinDurationsModal}
                  startDate={props.startDate}
                  endDate={props.endDate}
                  isAdmin={props.isAdmin}
                  isOnMobileOrTablet={true}
                  hideDataOutdateWarning={props.hideDataOutdateWarning || !ifEndDateGreaterThanToday} // only show when it navigates back && date is today or greater than today
                  hasMoreThanOneOrg={props.hasMoreThanOneOrg}
                />
              )}
            </div>
            {!props.fetchingWaitingArea && (
              <div className="right-hand-side-bottom-on-mobile">
                {bottomSession}
                <BottomLogo />
              </div>
            )}
          </div>
        </Container>
      )}
      {props.showSetMinDurationsModal && (
        <ModalSetMinDurations startDate={props.startDate} endDate={props.endDate} dispatch={props.dispatch} />
      )}
    </div>
  );
}

ViewAllReportsContent.propTypes = {
  reports: PropTypes.object, // Report data returned from the server
  hasReports: PropTypes.bool, // True = user has permission for viewing the report page
  timezone: PropTypes.number, // Timezone that logged in user set in the system, representing the offset of intlTimeStandard
  fetchingReports: PropTypes.bool, // Fetching data, for rendering the loading animation
  minConsultationDurValue: PropTypes.number,
  minMeetingDurValue: PropTypes.number,
};
